import { IOrganisationIndex } from "../model/OrganisationIndex";
import OrganisationIndexMapper from "../service/OrganisationIndexMapper";
import OrganisationIndexParamMapper from "../service/OrganisationIndexParamMapper";
import GetResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";

export default class FindConnectedIndexesInteractor {
  private resource: GetResourceEntriesInteractor<IOrganisationIndex>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(indexId: number, organisationId: number) {
    return this.resource.execute(
      `${Constants.organisationsPath}/${organisationId}/indexes/organisation/connected`,
      OrganisationIndexMapper,
      OrganisationIndexParamMapper,
      {
        params: { indexId: indexId }
      }
    );
  }
}
